export default "__VITE_ASSET__66ETCNS_VmdUAYAEpk8WsQ__"